// extracted by mini-css-extract-plugin
export var component = "ModuleWrapper-module--component--xau80";
export var header = "ModuleWrapper-module--header--tUVfi";
export var title = "ModuleWrapper-module--title--lBTjN";